module.exports = __webpack_public_path__ + "img/C1M.71620d0f.png";